<template>
  <v-row>
    <v-col cols="12" sm="6" md="4">
      <v-text-field
        readonly
        filled
        success
        shaped
        :value="ItemRow.ItemName"
        label="Item Name"
      ></v-text-field>
    </v-col>

    <!-- Total Price -->
    <v-col cols="12" sm="6" md="3">
      <v-text-field
        readonly
        filled
        success
        shaped
        :prefix="ItemRow.cash || ''"
        :value="TotalPrice ? TotalPrice.toLocaleString() : TotalPrice"
        :label="'Total ' + ItemRow.UnitType + ' price'"
      ></v-text-field>
    </v-col>
    <!-- Discount Fild -->
    <v-col cols="12" sm="6" md="2">
      <v-text-field
        outlined
        :prefix="ItemRow.cash || ''"
        type="number"
        v-model.number="ItemRow.Discount"
        :rules="[discountRule]"
        @update:error="OnError"
        label="Discount"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-text-field
        readonly
        filled
        success
        shaped
        :prefix="ItemRow.cash || ''"
        :value="afterDiscount ? afterDiscount.toLocaleString() : afterDiscount"
        :label="'Total ' + ItemRow.UnitType + ' price'"
      ></v-text-field>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    ItemRow: { type: Object, required: true },
    // OnError: { type: Function, required: true }
  },
  computed: {
    TotalPrice() {
      return this.ItemRow.unitPrice * this.ItemRow.qty;
    },
    afterDiscount() {
      return this.ItemRow.unitPrice * this.ItemRow.qty - this.ItemRow.Discount;
    },
  },
  watch: {
    // TotalPrice() {
    //   if (!this.ItemRow.exp) this.ItemRow.exp = this.ItemRow.qty;
    // }
  },
  methods: {
    OnError(v) {
      // console.log(this.ItemRow._id);
      this.$emit("OnError", { isError: v, _id: this.ItemRow._id });
    },
    discountRule(v) {
      return v >= 0 || "Negative Discount is not allowed";
    },
    // IsNum(v) {
    //   return !isNaN(v.replace(/,/g, "")) || "it is not number";
    // },

    // InputEventQty(v) {
    //   if (isNaN(v.replace(/,/g, ""))) return;
    //   this.ItemRow.qty = Number(v.replace(/,/g, ""));
    // }
  },
};
</script>
